import React from "react";
import "../../css/Wireframe.css";
import Banner from "../../components/Banner";
import Select from "react-select";
import axios from "axios";
import OtpInput from "../../components/OtpInput";
import Spinner from "../../components/Spinner";
import { Sidebar } from "./../../components/Sidebar";

const API = localStorage.getItem("assethost");
const usernameRegex = /^(?!\s*$)[-_a-zA-Z0-9 ]*$/;
const usernameError =
  "Username should only contain letters, digits, dash, or underscore";
const passwordRegex =
  // eslint-disable-next-line no-useless-escape
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;
const passwordError =
  "Password must be at least 8 characters, with uppercase, lowercase, number, and symbol.";
const nationalIdRegex = /^\d{2}-\d{6,7}[A-Z]\d{2}$/;
const ogPlaceholder = "00-000000(0)A00";
const placeholder1 = "00-000000A00";
const placeholder2 = "00-0000000A00";
const phoneRegex =
  /^\+?[0-9]{1,4}?[-.\s]?\(?[0-9]{1,3}?\)?[-.\s]?[0-9]{3,4}[-.\s]?[0-9]{3,4}$/;
const phoneError = "Not a valid phone number";

function dynamicNationalIdError(id) {
  const start = "Accepted format for national ID is ";
  let last = "";
  if (id.length >= 10 && /[A-Z]/.test(id[9]))
    last = id + placeholder1.substring(id.length);
  else if (id.length >= 10) last = id + placeholder2.substring(id.length);
  else last = id + ogPlaceholder.substring(id.length);
  return start + last;
}
function formatNationalId(e, state, field, isZimbabwean = true) {
  let currentValue = String(state[field] || "");
  let newValue = currentValue;
  let newPlaceholder =
    currentValue + ogPlaceholder.substring(currentValue.length);
  let error = "";
  e = e.toUpperCase();
  if (!isZimbabwean) {
    const newState = { ...state, [field]: e };
    return { newPlaceholder, error, newState };
  }
  if (e.length > currentValue.length && nationalIdRegex.test(currentValue)) {
    return { newPlaceholder, error, newState: state };
  }
  if (nationalIdRegex.test(e)) {
    newValue = e;
    newPlaceholder = e;
  } else if (
    nationalIdRegex.test(e + placeholder1.substring(e.length)) ||
    nationalIdRegex.test(e + placeholder2.substring(e.length))
  ) {
    if (e.length >= 10) {
      newValue = e;
      newPlaceholder = /[A-Z]/.test(e[9])
        ? e + placeholder1.substring(e.length)
        : e + placeholder2.substring(e.length);
    } else if (e.length === 2 && currentValue.length < 2) {
      newValue = e + "-";
      newPlaceholder = newValue + ogPlaceholder.substring(newValue.length);
    } else {
      newValue = e;
      newPlaceholder = e + ogPlaceholder.substring(e.length);
    }
  } else {
    error = dynamicNationalIdError(currentValue);
  }
  let newState = { ...state, [field]: newValue };
  return { newPlaceholder, error, newState };
}

export default class LawEnforcement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: "",
      middleName: "",
      surname: "",
      forceNumber: "",
      rankId: 0,
      stationId: 0,
      roleId: 0,
      nationality: "",
      nationalIdNumber: "",
      passportNumber: "",
      cellPhone: "",
      gender: "",
      username: "",
      password: "",
      passwordConfirm: "",
      otpCode: "",
      errors: {},
      idPlaceholder: ogPlaceholder,
      msg: "",
      toastColor: "",
      loading: false,
      valid: false,
      companyLookupData: {},
      ranks: [],
      stations: [],
      roles: [],
      otpId: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleRegister = this.handleRegister.bind(this);
    this.handleId = this.handleId.bind(this);
    this.verifyCellphone = this.verifyCellphone.bind(this);
    this.validate = this.validate.bind(this);
  }
  componentDidMount() {
    this.getCompanyLookupData();
    this.getDropdownLists();
  }

  isZimbabwean() {
    return this.state.nationality === "ZW";
  }

  getCompanyLookupData() {
    var self = this;
    axios
      .get(API + "/register/getcompanydropdownlists")
      .then(function (response) {
        self.setState({ companyLookupData: response.data || {} });
      })
      .catch(function (error) {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        self.setState({
          msg:
            error?.response?.data?.message ||
            "Failed to get lookup data. Refresh page or contact administrator.",
          toastColor: "danger",
        });
      });
  }
  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.validate);
  }
  handleSelect(name, option) {
    this.setState(
      {
        [name]: option
          ? option.value
          : typeof option === "string"
          ? option
          : "",
      },
      this.validate
    );
  }
  handleId(val, field = "nationalIdNumber") {
    const { newPlaceholder, error, newState } = formatNationalId(
      val,
      this.state,
      field,
      this.isZimbabwean()
    );
    this.setState(
      {
        [field]: newState[field],
        ...(field === "nationalIdNumber"
          ? { idPlaceholder: newPlaceholder }
          : {}),
        errors: { ...this.state.errors, [field]: error },
      },
      this.validate
    );
  }
  getDropdownLists() {
    this.setState({ loading: true, msg: "", toastColor: "" });

    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "Login details not properly recorded, please return to login screen",
        toastColor: "danger",
        loading: false,
      });
      setTimeout(() => {
        window.location.href = `/?redirectUrl=${
          window.location.pathname + window.location.search
        }`;
      }, 1600);
      return;
    }

    axios
      .get(API + "/law-enforcement/register/dropdownlists", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        this.setState({
          ranks: res.data.rankList || [],
          stations: res.data.stationList || [],
          roles: res.data.roleList || [],
        });
      })
      .catch((err) => {
        if (Number(err.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          msg:
            err?.response?.data?.message ||
            "Failed to get lookup data. Refresh page or contact administrator.",
          toastColor: "danger",
          loading: false,
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }
  validate() {
    let s = this.state;
    let errors = {};
    let valid = true;
    if (!s.firstName || !s.firstName.trim()) {
      errors.firstName = "First Name is required";
      valid = false;
    }
    if (!s.surname || !s.surname.trim()) {
      errors.surname = "Surname is required";
      valid = false;
    }
    if (!s.forceNumber || !s.forceNumber.trim()) {
      errors.forceNumber = "Force Number is required";
      valid = false;
    }
    if (!s.rankId || s.rankId === 0) {
      errors.rankId = "Rank is required";
      valid = false;
    }
    if (!s.stationId || s.stationId === 0) {
      errors.stationId = "Station is required";
      valid = false;
    }
    if (!s.roleId || s.roleId === 0) {
      errors.roleId = "Role is required";
      valid = false;
    }
    if (!s.nationality || !s.nationality.trim()) {
      errors.nationality = "Nationality is required";
      valid = false;
    }
    if (this.isZimbabwean()) {
      if (!s.nationalIdNumber || !s.nationalIdNumber.trim()) {
        errors.nationalIdNumber = "National ID is required";
        valid = false;
      } else if (!nationalIdRegex.test(s.nationalIdNumber)) {
        errors.nationalIdNumber = dynamicNationalIdError(s.nationalIdNumber);
        valid = false;
      }
    } else {
      if (!s.passportNumber || !s.passportNumber.trim()) {
        errors.passportNumber = "Passport Number is required";
        valid = false;
      }
    }
    if (!s.cellPhone || !s.cellPhone.trim()) {
      errors.cellPhone = "Cellphone is required";
      valid = false;
    } else if (!phoneRegex.test(s.cellPhone)) {
      errors.cellPhone = phoneError;
      valid = false;
    } else if (!s.otpId || s.otpId === 0) {
      errors.cellPhone = "Cellphone is not verified";
      valid = false;
    }
    if (!s.gender || !s.gender.trim()) {
      errors.gender = "Gender is required";
      valid = false;
    }
    if (!s.username || !s.username.trim()) {
      errors.username = "Username is required";
      valid = false;
    } else if (!usernameRegex.test(s.username)) {
      errors.username = usernameError;
      valid = false;
    }
    if (!s.password || !s.password.trim()) {
      errors.password = "Password is required";
      valid = false;
    } else if (!passwordRegex.test(s.password)) {
      errors.password = passwordError;
      valid = false;
    }
    if (!s.passwordConfirm || !s.passwordConfirm.trim()) {
      errors.passwordConfirm = "Password Confirm is required";
      valid = false;
    } else if (s.password !== s.passwordConfirm) {
      errors.passwordConfirm = "Passwords do not match";
      valid = false;
    } else if (!passwordRegex.test(s.passwordConfirm)) {
      errors.passwordConfirm = passwordError;
      valid = false;
    }
    if (!s.otpCode || !s.otpCode.trim()) {
      errors.otpCode = "OTP is required";
      valid = false;
    }
    this.setState({ errors, valid });
    return valid;
  }
  verifyCellphone(e) {
    if (e) e.preventDefault();
    if (!this.state.cellPhone || !phoneRegex.test(this.state.cellPhone)) {
      this.setState({
        errors: { ...this.state.errors, cellPhone: phoneError },
      });
      return;
    }
    this.setState({ loading: true, msg: "", toastColor: "" });
    axios
      .post(API + "/register/mobile/generateotpcode", null, {
        params: { mobile: this.state.cellPhone },
      })
      .then((response) => {
        this.setState({ otpId: response.data, loading: false });
      })
      .catch(() => {
        this.setState({
          msg: "Failed to get OTP.",
          toastColor: "danger",
          loading: false,
        });
      });
  }
  handleRegister(e) {
    e.preventDefault();
    this.setState({ loading: true, msg: "", toastColor: "" });
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
        loading: false,
      });
      return;
    }

    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "Login details not properly recorded, please return to login screen",
        toastColor: "danger",
        loading: false,
      });
      setTimeout(() => {
        window.location.href = `/?redirectUrl=${
          window.location.pathname + window.location.search
        }`;
      }, 1600);
      return;
    }

    const req = {
      user: {
        username: this.state.username,
        password: this.state.password,
        userType: "LAW_ENFORCEMENT",
        fullName: [
          this.state.firstName,
          this.state.middleName,
          this.state.surname,
        ].join(" "),
        mobileVerified: "NO",
        activeStatus: "YES",
        emailVerified: "NO",
        isPaidService: "NO",
        roleId: this.state.roleId,
      },
      otpCode: Number(this.state.otpCode),
      lawEnforcementProfile: {
        id: 0,
        firstName: this.state.firstName,
        surname: this.state.surname,
        middleName: this.state.middleName,
        forceNumber: this.state.forceNumber,
        rankId: this.state.rankId,
        stationId: this.state.stationId,
        nationalIdNumber: this.state.nationalIdNumber,
        passportNumber: this.state.passportNumber,
        nationality: this.state.nationality,
        cellPhone: this.state.cellPhone,
      },
    };
    var self = this;
    axios
      .post(API + "/law-enforcement/register", req, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(function (response) {
        if (response.data.success) {
          self.setState({
            msg: "Registration successful! Redirecting to login...",
            toastColor: "success",
            loading: false,
          });
          setTimeout(() => {
            window.location.href = "/";
          }, 1700);
        } else {
          self.setState({
            msg: response.data.message || "Registration failed",
            toastColor: "danger",
            loading: false,
          });
          if (
            response.data.message &&
            response.data.message.includes("username already exist")
          ) {
            self.setState({
              errors: { ...self.state.errors, username: response.data.message },
            });
          }
        }
      })
      .catch(function (error) {
        self.setState({
          msg:
            error?.response?.data?.message ||
            "Registration failed. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }
  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }
    if (s.loading) {
      return <Spinner className="" />;
    }
    return (
      <div className="d-flex flex-column min-vh-100">
        <Sidebar />
        <div className="d-flex flex-column flex-grow-1">
          <Banner title="Register as Law Enforcement" align="center" />
          {divMsg}
          <form
            className="d-flex flex-column align-items-center w-100 mt-2 overflow-auto was-validated"
            autoComplete="off"
            onSubmit={this.handleRegister}
          >
            <div className="w-100" style={{ maxWidth: "1200px" }}>
              <div className="row g-3">
                {/* First Name */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    <i className="bi bi-person me-2"></i>First Name
                  </label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-person-fill"></i></span>
                    <input
                      type="text"
                      name="firstName"
                      className={`form-control ${
                        s.errors.firstName ? "z-0" : "z-0"
                      }`}
                      value={s.firstName}
                      onChange={this.handleChange}
                      required
                      autoFocus
                    />
                  </div>
                  {s.errors.firstName && (
                    <div className="text-danger small">{s.errors.firstName}</div>
                  )}
                </div>

                {/* Middle Name */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    <i className="bi bi-person me-2"></i>Middle Name
                  </label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-person-fill"></i></span>
                    <input
                      type="text"
                      name="middleName"
                      className={`form-control ${
                        s.errors.middleName ? "z-0" : "z-0"
                      }`}
                      value={s.middleName}
                      onChange={this.handleChange}
                    />
                  </div>
                  {s.errors.middleName && (
                    <div className="text-danger small">{s.errors.middleName}</div>
                  )}
                </div>

                {/* Surname */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    <i className="bi bi-person me-2"></i>Surname
                  </label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-person-fill"></i></span>
                    <input
                      type="text"
                      name="surname"
                      className={`form-control ${
                        s.errors.surname ? "z-0" : "z-0"
                      }`}
                      value={s.surname}
                      onChange={this.handleChange}
                      required
                    />
                  </div>
                  {s.errors.surname && (
                    <div className="text-danger small">{s.errors.surname}</div>
                  )}
                </div>

                {/* Force Number */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    <i className="bi bi-hash me-2"></i>Force Number
                  </label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-hash"></i></span>
                    <input
                      type="text"
                      name="forceNumber"
                      className={`form-control ${
                        s.errors.forceNumber ? "z-0" : "z-0"
                      }`}
                      value={s.forceNumber}
                      onChange={this.handleChange}
                      required
                    />
                  </div>
                  {s.errors.forceNumber && (
                    <div className="text-danger small">{s.errors.forceNumber}</div>
                  )}
                </div>

                {/* Rank */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    <i className="bi bi-award me-2"></i>Rank
                  </label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-award-fill"></i></span>
                    <Select
                      name="rankId"
                      options={s.ranks.map((r) => ({
                        value: r.id,
                        label: r.name,
                      }))}
                      value={
                        s.ranks.find((r) => r.id === s.rankId)
                          ? {
                              value: s.rankId,
                              label: s.ranks.find((r) => r.id === s.rankId).name,
                            }
                          : null
                      }
                      onChange={(option) => this.handleSelect("rankId", option)}
                      className={`form-control ${
                        s.errors.rankId ? "z-0" : "z-0"
                      }`}
                      required
                    />
                  </div>
                  {s.errors.rankId && (
                    <div className="text-danger small">{s.errors.rankId}</div>
                  )}
                </div>

                {/* Station */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    <i className="bi bi-building me-2"></i>Station
                  </label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-building-fill"></i></span>
                    <Select
                      name="stationId"
                      options={s.stations.map((r) => ({
                        value: r.id,
                        label: r.name,
                      }))}
                      value={
                        s.stations.find((r) => r.id === s.stationId)
                          ? {
                              value: s.stationId,
                              label: s.stations.find((r) => r.id === s.stationId)
                                .name,
                            }
                          : null
                      }
                      onChange={(option) =>
                        this.handleSelect("stationId", option)
                      }
                      className={`form-control ${
                        s.errors.stationId ? "" : ""
                      }`}
                      required
                    />
                  </div>
                  {s.errors.stationId && (
                    <div className="text-danger small">{s.errors.stationId}</div>
                  )}
                </div>

                {/* Role */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    <i className="bi bi-person-badge me-2"></i>Role
                  </label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-person-badge-fill"></i></span>
                    <Select
                      name="roleId"
                      options={s.roles.map((r) => ({
                        value: r.id,
                        label: r.name,
                      }))}
                      value={
                        s.roles.find((r) => r.id === s.roleId)
                          ? {
                              value: s.roleId,
                              label: s.roles.find((r) => r.id === s.roleId).name,
                            }
                          : null
                      }
                      onChange={(option) => this.handleSelect("roleId", option)}
                      className={`form-control ${
                        s.errors.roleId ? "" : ""
                      }`}
                      required
                    />
                  </div>
                  {s.errors.roleId && (
                    <div className="text-danger small">{s.errors.roleId}</div>
                  )}
                </div>

                {/* Nationality */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    <i className="bi bi-flag me-2"></i>Nationality
                  </label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-flag-fill"></i></span>
                    <Select
                      name="nationality"
                      value={(s.companyLookupData.countrys || []).find(
                        ({ value }) => value === s.nationality
                      )}
                      onChange={(option) => {
                        this.handleId("", "nationalIdNumber");
                        this.handleId("", "passportNumber");
                        this.setState({ idPlaceholder: ogPlaceholder });
                        this.handleSelect("nationality", option);
                      }}
                      className={`form-control ${
                        s.errors.nationality ? "" : ""
                      }`}
                      required
                      options={s.companyLookupData.countrys || []}
                    />
                  </div>
                  {s.errors.nationality && (
                    <div className="text-danger small">{s.errors.nationality}</div>
                  )}
                </div>

                {/* National ID or Passport Number */}
                {!!s.nationality && this.isZimbabwean() ? (
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      <i className="bi bi-card-text me-2"></i>National ID
                    </label>
                    <div className="input-group">
                      <span className="input-group-text"><i className="bi bi-card-text"></i></span>
                      <input
                        type="text"
                        name="nationalIdNumber"
                        className={`form-control ${
                          s.errors.nationalIdNumber ? "z-0" : "z-0"
                        }`}
                        value={s.nationalIdNumber}
                        placeholder={s.idPlaceholder}
                        onChange={(e) =>
                          this.handleId(e.target.value, "nationalIdNumber")
                        }
                        required
                      />
                    </div>
                    {s.errors.nationalIdNumber && (
                      <div className="text-danger small">{s.errors.nationalIdNumber}</div>
                    )}
                  </div>
                ) : !!s.nationality ? (
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      <i className="bi bi-passport me-2"></i>Passport Number
                    </label>
                    <div className="input-group">
                      <span className="input-group-text"><i className="bi bi-passport"></i></span>
                      <input
                        type="text"
                        name="passportNumber"
                        className={`form-control ${
                          s.errors.passportNumber ? "z-0" : "z-0"
                        }`}
                        value={s.passportNumber}
                        onChange={(e) =>
                          this.handleId(e.target.value, "passportNumber")
                        }
                        required
                      />
                    </div>
                    {s.errors.passportNumber && (
                      <div className="text-danger small">{s.errors.passportNumber}</div>
                    )}
                  </div>
                ) : null}

                {/* Gender */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    <i className="bi bi-gender-ambiguous me-2"></i>Gender
                  </label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-gender-ambiguous"></i></span>
                    <select
                      name="gender"
                      className={`form-select ${
                        s.errors.gender ? "z-0" : "z-0"
                      }`}
                      value={s.gender}
                      onChange={this.handleChange}
                      required
                    >
                      <option value="">Select</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  {s.errors.gender && (
                    <div className="text-danger small">{s.errors.gender}</div>
                  )}
                </div>

                {/* Cellphone */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    <i className="bi bi-phone me-2"></i>Cellphone
                  </label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-phone-fill"></i></span>
                    <input
                      type="text"
                      name="cellPhone"
                      className={`form-control ${
                        s.errors.cellPhone ? "z-0" : "z-0"
                      }`}
                      value={s.cellPhone}
                      onChange={this.handleChange}
                      required
                    />
                    {!s.otpId && (
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={this.verifyCellphone}
                      >
                        Verify
                      </button>
                    )}
                  </div>
                  {s.errors.cellPhone && (
                    <div className="text-danger small">{s.errors.cellPhone}</div>
                  )}
                </div>

                {/* OTP Code */}
                {s.otpId && (
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      <i className="bi bi-shield-lock me-2"></i>OTP Code
                    </label>
                    <div className="input-group">
                      <span className="input-group-text"><i className="bi bi-shield-lock-fill"></i></span>
                      <OtpInput
                        key={`law-enforcement-otp`}
                        length={5}
                        onReset={(code) =>
                          this.setState({ otpCode: code }, this.validate)
                        }
                        onComplete={(code) =>
                          this.setState({ otpCode: code }, this.validate)
                        }
                        autofocus={false}
                      />
                    </div>
                    {s.errors.otpCode && (
                      <div className="text-danger small">{s.errors.otpCode}</div>
                    )}
                  </div>
                )}

                {/* Username */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label fw-semibold">
                      <i className="bi bi-at me-2"></i>Username
                    </label>
                    <div className="input-group">
                      <span className="input-group-text"><i className="bi bi-at"></i></span>
                      <input
                        type="text"
                        name="username"
                        className={`form-control ${
                          s.errors.username ? "z-0" : "z-0"
                        }`}
                        value={s.username}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    {s.errors.username && (
                      <div className="text-danger small">{s.errors.username}</div>
                    )}
                  </div>
                </div>

                {/* Password */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label fw-semibold">
                      <i className="bi bi-lock me-2"></i>Password
                    </label>
                    <div className="input-group">
                      <span className="input-group-text"><i className="bi bi-lock-fill"></i></span>
                      <input
                        type="password"
                        name="password"
                        className={`form-control ${
                          s.errors.password ? "z-0" : "z-0"
                        }`}
                        value={s.password}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    {s.errors.password && (
                      <div className="text-danger small">{s.errors.password}</div>
                    )}
                  </div>
                </div>

                {/* Password Confirm */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label fw-semibold">
                      <i className="bi bi-lock me-2"></i>Password Confirm
                    </label>
                    <div className="input-group">
                      <span className="input-group-text"><i className="bi bi-lock-fill"></i></span>
                      <input
                        type="password"
                        name="passwordConfirm"
                        className={`form-control ${
                          s.errors.passwordConfirm ? "z-0" : "z-0"
                        }`}
                        value={s.passwordConfirm}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    {s.errors.passwordConfirm && (
                      <div className="text-danger small">{s.errors.passwordConfirm}</div>
                    )}
                  </div>
                </div>
              </div>

              {/* Submit Buttons */}
              <div className="d-flex justify-content-center gap-3 mt-4">
                {s.valid && (
                  <button type="submit" className="btn btn-primary">
                    <i className="bi bi-check-circle me-2"></i>Register
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => window.history.back()}
                >
                  <i className="bi bi-x-circle me-2"></i>Cancel
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
